// extracted by mini-css-extract-plugin
export var cardHeader = "_gu-0";
export var reorderHandle = "_gu-3";
export var titleArea = "_gu-1";
export var titleAreaWithHandle = "_gu-2";